import React from 'react';
import { PfErrorUtilsProvider } from '../ErrorUtilsContext';
export var UtilsProvider = function UtilsProvider(_ref) {
  var utils = _ref.utils,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(PfErrorUtilsProvider, {
    errorUtils: utils.errorUtils
  }, children);
};